import { useCallback } from 'react'
import { useWindows } from '@/hooks/useWindows'
import { offerPromptToChat } from '@/lib/promptHandoff'

/** Puts a prompt into the composer of the active chat, opening one if needed. */
export function useSendPromptToChat() {
  const { windows, activeId, openWindow, focusWindow, toggleMinimize } = useWindows()

  return useCallback(
    (text: string) => {
      const chats = windows.filter((window) => window.appId === 'communicator2')
      const chat = chats.find((window) => window.id === activeId) ?? chats[chats.length - 1]
      if (!chat) {
        offerPromptToChat(text)
        void openWindow('communicator2')
        return
      }
      if (chat.minimized) toggleMinimize(chat.id)
      focusWindow(chat.id)
      offerPromptToChat(text, chat.id)
    },
    [windows, activeId, openWindow, focusWindow, toggleMinimize],
  )
}
